import React from "react";
import { Link } from "react-router-dom";
import { SUPPORT_EMAIL } from "../SEO/siteOrigin";

const COMPACT_LINES = [
  "Plans renew each year until you cancel in Manage billing. If you cancel, your plan stays on until the end of the year you already paid.",
  "Switching to Priority charges the difference now. If you switch to AI Assist, Priority stays on through the year you paid, with no credit.",
  "Imported data stays. New imports stop when the plan ends. The first tournament still includes AI Assist.",
];

const PlanTermsLinks = () => (
  <p className="text-sm text-brand-muted">
    Refund questions:{" "}
    <a
      href={`mailto:${SUPPORT_EMAIL}`}
      className="underline text-brand-gold-ink"
    >
      {SUPPORT_EMAIL}
    </a>
    . See the{" "}
    <Link
      to="/refund-policy#organization-plans"
      className="underline text-brand-gold-ink"
    >
      Refund policy
    </Link>{" "}
    and{" "}
    <Link
      to="/terms-of-service#organization-plans"
      className="underline text-brand-gold-ink"
    >
      Terms of Service
    </Link>
    .
  </p>
);

/**
 * @param {"compact" | "accordion"} [variant]
 * compact — Plan screen (~3 lines)
 * accordion — /pricing full-width FAQ
 */
const PlanTerms = ({
  heading = "Renewal and cancel",
  variant = "compact",
}) => {
  const body = (
    <div className="space-y-3">
      <ul className="space-y-2 text-sm text-brand-charcoal">
        {COMPACT_LINES.map((line) => (
          <li key={line}>{line}</li>
        ))}
      </ul>
      <PlanTermsLinks />
    </div>
  );

  if (variant === "accordion") {
    return (
      <section
        className="card-board w-full"
        aria-labelledby="plan-terms-heading"
      >
        <details className="group p-6">
          <summary
            id="plan-terms-heading"
            className="font-display font-bold text-lg text-brand-charcoal cursor-pointer list-none flex items-center justify-between gap-3"
          >
            <span>{heading}</span>
            <span
              className="text-brand-muted text-sm font-medium group-open:hidden"
              aria-hidden="true"
            >
              Show
            </span>
            <span
              className="text-brand-muted text-sm font-medium hidden group-open:inline"
              aria-hidden="true"
            >
              Hide
            </span>
          </summary>
          <div className="mt-4 border-t border-brand-charcoal/10 pt-4">
            {body}
          </div>
        </details>
      </section>
    );
  }

  return (
    <section
      className="card-board p-6 space-y-3"
      aria-labelledby="plan-terms-heading"
    >
      <h2
        id="plan-terms-heading"
        className="font-display font-bold text-lg text-brand-charcoal"
      >
        {heading}
      </h2>
      {body}
    </section>
  );
};

export default PlanTerms;
